module.exports = __webpack_public_path__ + "img/activeicon-hierarchy.8a7dde37.svg";